import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { Item } from '../../../core/components/listbox/listbox.component';
import { ModalService } from '../../../core/services/modal.service';

@Component({
    selector: 'tt-category-link-add',
    templateUrl: './category-link-add.component.html',
    styleUrls: ['./category-link-add.component.css']
})
export class CategoryLinkAddComponent implements OnInit {
    categoryKeynoBelongTo;

    public setting?: Setting;

    public categoryNameNew: string = '';

    public itemsListNotLinked: Item[] = [];

    public categoryNameButtons: FormButton[] = [{ id: 'new', icon: 'fa fa-plus', type: 'success', onClick: () => this.addLink() }];

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.categoryKeynoBelongTo = this.stateService.getStateParams()['category_keyno_belongto'];
    }

    private async loadSetting() {
        if (!!this.categoryKeynoBelongTo) {
            this.setting = (await this.datatask.Post(630, { category_keyno: this.categoryKeynoBelongTo }))[0];
        }
    }

    private async loadNotLinked() {
        if (!!this.categoryKeynoBelongTo) {
            this.itemsListNotLinked = await this.datatask.Post(631, { category_keyno_belongto: this.categoryKeynoBelongTo });
        }
    }

    private async addLink() {
        if (!!this.categoryKeynoBelongTo) {
            const response = (await this.datatask.Post(632, {
                category_keyno: '0',
                category_keyno_belongto: this.categoryKeynoBelongTo,
                category_name: this.categoryNameNew
            }))[0];

            if (response?.status_no !== '0') {
                this.modal.show({
                    type: 'warning',
                    title: 'error',
                    translateTitle: true,
                    message: response.status_message
                });
            } else {
                this.stateService.back();
            }
        }
    }

    public async goBackToPrevious(event: { item: Item; event: MouseEvent }) {
        if (!!this.categoryKeynoBelongTo) {
            const response = (await this.datatask.Post(632, {
                category_keyno: event.item.item_id,
                category_keyno_belongto: this.categoryKeynoBelongTo,
                category_name: ''
            }))[0];

            if (response?.status_no !== '0') {
                this.modal.show({
                    type: 'warning',
                    title: 'error',
                    translateTitle: true,
                    message: response.status_message
                });
            } else {
                this.stateService.back();
            }
        }
    }

    private async init() {
        this.loadSetting();
        this.loadNotLinked();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    category_keyno: string;
    category_name: string;
    orderby: string;
    item_badge: string;
}
